import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    getWebhookDetailFetchSuccess,
    getWebhookDetailFetchFailure,
    getWebhookDetailHistoryFetchSuccess,
    getWebhookDetailHistoryFetchFailure,
    createWebhookDetailFetchSuccess,
    createWebhookDetailFetchFailure,
    updateWebhookDetailFetchSuccess,
    updateWebhookDetailFetchFailure,
    deleteWebhookFetchSuccess,
    deleteWebhookFetchFailure,
    activateWebhookFetchSuccess,
    activateWebhookFetchFailure,
    deactivateWebhookFetchSuccess,
    deactivateWebhookFetchFailure,
} from './reducer';
import { getWebhooksListFetch } from '../webhooksList/reducer';
import {
    WebhookDetailChangelogResType,
    WebhookDetailResType,
} from 'src/types/webhookDetail';
import { WebhookRecordType } from 'src/types/webhook';
import translate from '@translate';

const getWebhookDetailFetchRequest = async (idWebhook: string) => {
    const res = await api('get', `api/secure/webhooks/${idWebhook}`);
    return res.data;
};

function* getWebhookDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: WebhookDetailResType = yield call((): any =>
            getWebhookDetailFetchRequest(action.payload)
        );
        yield put(getWebhookDetailFetchSuccess(response));
    } catch (error) {
        yield put(getWebhookDetailFetchFailure({ error }));
    }
}

export function* getWebhookDetailFetchWatch() {
    yield takeEvery('webhookDetail/getWebhookDetailFetch', getWebhookDetailFetch);
}

const getWebhookDetailHistoryFetchRequest = async (idWebhook: string) => {
    const res = await api('get', `api/secure/webhooks/${idWebhook}/history`);
    return res.data;
};

function* getWebhookDetailHistoryFetch(action: { type: string; payload: string }) {
    try {
        const response: WebhookDetailChangelogResType = yield call((): any =>
            getWebhookDetailHistoryFetchRequest(action.payload)
        );
        yield put(getWebhookDetailHistoryFetchSuccess(response));
    } catch (error) {
        yield put(getWebhookDetailHistoryFetchFailure({ error }));
    }
}

export function* getWebhookDetailHistoryFetchWatch() {
    yield takeEvery('webhookDetail/getWebhookDetailHistoryFetch', getWebhookDetailHistoryFetch);
}

const createWebhookDetailFetchRequest = async (data: WebhookRecordType) => {
    const res = await api('post', 'api/secure/webhooks', data);
    return res.data;
};

function* createWebhookDetailFetch(action: { type: string; payload: WebhookRecordType }) {
    try {
        const response: WebhookDetailResType = yield call((): any =>
            createWebhookDetailFetchRequest(action.payload)
        );
        yield put(
            createWebhookDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('webhookDetail.message.webhookCreated') },
            })
        );
    } catch (error) {
        yield put(createWebhookDetailFetchFailure({ error }));
    }
}

export function* createWebhookDetailFetchWatch() {
    yield takeEvery('webhookDetail/createWebhookDetailFetch', createWebhookDetailFetch);
}

const updateWebhookDetailFetchRequest = async (params: { idWebhook: string; data: WebhookRecordType }) => {
    const res = await api('put', `api/secure/webhooks/${params.idWebhook}`, params.data);
    return res.data;
};

function* updateWebhookDetailFetch(action: {
    type: string;
    payload: { idWebhook: string; data: WebhookRecordType };
}) {
    try {
        const response: WebhookDetailResType = yield call((): any =>
            updateWebhookDetailFetchRequest(action.payload)
        );
        yield put(
            updateWebhookDetailFetchSuccess({
                ...response,
                messageSuccess: { title: translate('webhookDetail.message.webhookUpdate') },
            })
        );
    } catch (error) {
        yield put(updateWebhookDetailFetchFailure({ error }));
    }
}

export function* updateWebhookDetailFetchWatch() {
    yield takeEvery('webhookDetail/updateWebhookDetailFetch', updateWebhookDetailFetch);
}

const deleteWebhookFetchRequest = async (idWebhook: string) => {
    const res = await api('delete', `api/secure/webhooks/${idWebhook}`);
    return res.data;
};

function* deleteWebhookFetch(action: { type: string; payload: string }) {
    try {
        const response: WebhookDetailResType = yield call((): any => deleteWebhookFetchRequest(action.payload));
        yield put(
            deleteWebhookFetchSuccess({
                ...response,
                messageSuccess: { title: translate('webhookDetail.message.webhookDeleted') },
            })
        );
    } catch (error) {
        yield put(deleteWebhookFetchFailure({ error }));
    }
}

export function* deleteWebhookFetchWatch() {
    yield takeEvery('webhookDetail/deleteWebhookFetch', deleteWebhookFetch);
}

const activateWebhookFetchRequest = async (idWebhook: number) => {
    const res = await api('put', `api/secure/webhooks/${idWebhook}/activate`);
    return res.data;
};

function* activateWebhookFetch(action: { type: string; payload: number }) {
    try {
        yield call((): any => activateWebhookFetchRequest(action.payload));
        yield put(
            activateWebhookFetchSuccess({
                messageSuccess: { title: translate('webhooks.message.webhookActivated') },
            })
        );
        yield put(getWebhooksListFetch());
    } catch (error) {
        yield put(activateWebhookFetchFailure({ error }));
    }
}

export function* activateWebhookFetchWatch() {
    yield takeEvery('webhookDetail/activateWebhookFetch', activateWebhookFetch);
}

const deactivateWebhookFetchRequest = async (idWebhook: number) => {
    const res = await api('put', `api/secure/webhooks/${idWebhook}/deactivate`);
    return res.data;
};

function* deactivateWebhookFetch(action: { type: string; payload: number }) {
    try {
        yield call((): any => deactivateWebhookFetchRequest(action.payload));
        yield put(
            deactivateWebhookFetchSuccess({
                messageSuccess: { title: translate('webhooks.message.webhookDeactivated') },
            })
        );
        yield put(getWebhooksListFetch());
    } catch (error) {
        yield put(deactivateWebhookFetchFailure({ error }));
    }
}

export function* deactivateWebhookFetchWatch() {
    yield takeEvery('webhookDetail/deactivateWebhookFetch', deactivateWebhookFetch);
}
